import parse from 'html-react-parser'
import Head from 'next/head'

import { FRONT_BASE_URL } from '@/constants'

import { WPMeta } from '@/types'

export type MetaProps = {
  pageProps: WPMeta
}

const Meta = ({ pageProps }: MetaProps) => {
  const robotsContent = [
    pageProps?.meta_robots?.is_robots_noindex ? 'noindex' : 'index',
    pageProps?.meta_robots?.is_robots_nofollow ? 'nofollow' : 'follow'
  ]
    .filter(Boolean)
    .join(', ')

  return pageProps?.yoast_head ? (
    <Head>
      {parse(pageProps.yoast_head.replace(/"\//g, `"${FRONT_BASE_URL}/`) || '')}
      {robotsContent ? <meta name="robots" content={robotsContent} /> : null}
      {pageProps.yoast_canonical ? (
        <link rel="canonical" href={`${FRONT_BASE_URL}${pageProps.yoast_canonical}`} />
      ) : null}
    </Head>
  ) : null
}

export default Meta
